/* ==========================================================================
   DCA CLINICAL — product.js
   Variant resolution, purchase-mode cards, gallery, sticky add-to-cart.

   Placeholder tokens in translated strings use [square] brackets, never
   {curly}. A curly brace inside a Liquid tag truncates the tag at the first
   "}" and Shopify rejects the entire theme upload. Keep it that way.
   ========================================================================== */
(function () {
  'use strict';

  var DCA = window.DCA || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var root = $('[data-product-root]');
  if (!root) return;

  var dataEl = $('[data-product-json]', root);
  if (!dataEl) return;

  var productData;
  try { productData = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var variants = productData.variants || [];
  var form = $('.pdp__form', root);
  var idInput = form ? form.querySelector('[data-variant-id]') : null;
  var priceEl = $('[data-price-target]', root);
  var stockEl = $('[data-stock-target]', root);
  var addBtn = form ? form.querySelector('[data-add-btn]') : null;
  var stickyPrice = $('[data-sticky-price]');
  var lowStockThreshold = parseInt(root.dataset.lowStock, 10) || 10;
  var servings = parseInt(root.dataset.servings, 10) || 0;

  /* ------------------------------------------------------- variant logic */

  function currentOptions() {
    var opts = [];
    $$('[data-option-index]', root).forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10);
      var checked = group.querySelector('input:checked');
      if (checked) opts[idx] = checked.value;
    });
    return opts;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] !== undefined && v.options[j] !== opts[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  /* Out-of-stock combinations stay visible but disabled. Hiding them makes the
     shopper think the option does not exist. */
  function updateOptionAvailability(opts) {
    $$('[data-option-index]', root).forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10);
      $$('input', group).forEach(function (input) {
        var probe = opts.slice();
        probe[idx] = input.value;
        var candidates = variants.filter(function (v) {
          for (var j = 0; j < probe.length; j++) {
            if (j > idx) continue;
            if (probe[j] !== undefined && v.options[j] !== probe[j]) return false;
          }
          return true;
        });
        var anyAvailable = candidates.some(function (v) { return v.available; });
        input.disabled = candidates.length > 0 ? !anyAvailable : true;
      });
    });
  }

  /* ---------------------------------------------------------- purchase mode */

  function selectedMode() {
    var checked = root.querySelector('[data-buymode]:checked');
    return checked ? checked.value : 'onetime';
  }

  function findAllocation(variant) {
    if (!variant || !variant.selling_plan_allocations) return null;
    var allocs = variant.selling_plan_allocations;
    if (!allocs.length) return null;
    var planSelect = $('[data-selling-plan]', root);
    var wanted = planSelect ? planSelect.value : null;
    if (wanted) {
      for (var i = 0; i < allocs.length; i++) {
        if (String(allocs[i].selling_plan_id) === String(wanted)) return allocs[i];
      }
    }
    return allocs[0];
  }

  function syncSellingPlanInput() {
    var input = $('[data-selling-plan-input]', root);
    if (!input) return;
    if (selectedMode() === 'subscribe') {
      var planSelect = $('[data-selling-plan]', root);
      input.value = planSelect ? planSelect.value : '';
      input.disabled = false;
    } else {
      input.value = '';
      input.disabled = true;
    }
  }

  /* The selected card must LOOK selected. Pre-selecting subscription while
     visually highlighting one-time is a material-terms problem, not a style
     preference. */
  function paintCards() {
    var mode = selectedMode();
    $$('[data-purchase-card]', root).forEach(function (card) {
      card.classList.toggle('is-selected', card.dataset.mode === mode);
    });
  }

  function perServing(cents) {
    if (!servings || servings <= 0) return '';
    var label = root.dataset.perServingLabel || 'per serving';
    return DCA.formatMoney(Math.round(cents / servings)) + ' ' + label;
  }

  /* Per-serving price on BOTH cards — that is what makes the saving concrete
     instead of an abstract percentage. */
  function paintCardPrices(variant) {
    if (!variant) return;
    var oneTime = $('[data-onetime-price]', root);
    var sub = $('[data-subscribe-price]', root);

    if (oneTime) {
      oneTime.innerHTML = DCA.formatMoney(variant.price) +
        (servings > 0 ? '<span class="pcard__meta">' + perServing(variant.price) + '</span>' : '');
    }
    if (sub) {
      var alloc = findAllocation(variant);
      if (alloc) {
        var html = DCA.formatMoney(alloc.price);
        if (alloc.price < variant.price) {
          html += '<s>' + DCA.formatMoney(variant.price) + '</s>';
        }
        if (servings > 0) html += '<span class="pcard__meta">' + perServing(alloc.price) + '</span>';
        sub.innerHTML = html;
      } else {
        sub.innerHTML = DCA.formatMoney(variant.price);
      }
    }
  }

  /* -------------------------------------------------------------- painting */

  function renderPrice(variant) {
    if (!priceEl || !variant) return;
    var price = variant.price;
    var compare = variant.compare_at_price;

    if (selectedMode() === 'subscribe') {
      var alloc = findAllocation(variant);
      if (alloc) {
        compare = variant.price;
        price = alloc.price;
      }
    }

    var html = '<div class="price price--lg"><span class="price__current">' + DCA.formatMoney(price) + '</span>';
    if (compare && compare > price) {
      html += '<s class="price__compare">' + DCA.formatMoney(compare) + '</s>';
      html += '<span class="badge badge--save">' +
              ((DCA.strings && DCA.strings.saveWord) || 'Save') + ' ' +
              DCA.formatMoney(compare - price) + '</span>';
    }
    if (servings > 0) {
      html += '<span class="price__unit">' + perServing(price) + '</span>';
    }
    html += '</div>';
    priceEl.innerHTML = html;

    if (stickyPrice) stickyPrice.textContent = DCA.formatMoney(price);
  }

  function renderStock(variant) {
    if (!stockEl) return;
    if (!variant) {
      stockEl.className = 'stock stock--out';
      stockEl.textContent = root.dataset.unavailableLabel || 'Unavailable';
      return;
    }
    if (!variant.available) {
      stockEl.className = 'stock stock--out';
      stockEl.textContent = root.dataset.soldOutLabel || 'Sold out';
      return;
    }
    if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowStockThreshold) {
      stockEl.className = 'stock stock--low';
      stockEl.textContent = (root.dataset.lowStockLabel || 'Only [count] left')
        .replace('[count]', variant.inventory_quantity);
      return;
    }
    stockEl.className = 'stock';
    stockEl.textContent = root.dataset.inStockLabel || 'In stock';
  }

  function renderButton(variant) {
    if (!addBtn) return;
    var label;
    if (!variant) { label = root.dataset.unavailableLabel || 'Unavailable'; addBtn.disabled = true; }
    else if (!variant.available) { label = root.dataset.soldOutLabel || 'Sold out'; addBtn.disabled = true; }
    else { label = root.dataset.addLabel || 'Add to cart'; addBtn.disabled = false; }
    addBtn.textContent = label;
    addBtn.dataset.originalText = label;
    $$('[data-sticky-add]').forEach(function (b) {
      b.textContent = label;
      b.disabled = addBtn.disabled;
    });
  }

  function syncUrl(variant) {
    if (!variant || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function scrollGalleryToVariant(variant) {
    if (!variant || !variant.featured_media) return;
    var slide = $('[data-media-id="' + variant.featured_media.id + '"]');
    if (slide && slide.parentElement) {
      slide.parentElement.scrollTo({ left: slide.offsetLeft - slide.parentElement.offsetLeft, behavior: 'smooth' });
    }
  }

  function update() {
    var opts = currentOptions();
    var variant = findVariant(opts) || null;
    updateOptionAvailability(opts);
    if (idInput && variant) idInput.value = variant.id;
    paintCards();
    paintCardPrices(variant);
    renderPrice(variant);
    renderStock(variant);
    renderButton(variant);
    syncUrl(variant);
    scrollGalleryToVariant(variant);
    root.dispatchEvent(new CustomEvent('dca:variant:change', { detail: { variant: variant } }));
  }

  $$('[data-option-index] input', root).forEach(function (input) {
    input.addEventListener('change', update);
  });

  $$('[data-buymode]', root).forEach(function (radio) {
    radio.addEventListener('change', function () { syncSellingPlanInput(); update(); });
  });

  var planSelectEl = $('[data-selling-plan]', root);
  if (planSelectEl) {
    planSelectEl.addEventListener('change', function () { syncSellingPlanInput(); update(); });
    /* The select lives inside a <label>; a click on it must not re-toggle the card. */
    planSelectEl.addEventListener('click', function (e) { e.stopPropagation(); });
  }

  /* ------------------------------------------------------------ gallery */

  var slides = $('[data-gallery-slides]');
  if (slides) {
    var thumbs = $$('[data-gallery-thumb]');

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = $('[data-media-id="' + btn.dataset.target + '"]');
        if (target) slides.scrollTo({ left: target.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      });
    });

    var syncActive = function () {
      var i = Math.round(slides.scrollLeft / slides.clientWidth);
      $$('[data-gallery-slide]', slides).forEach(function (slide, idx) {
        var id = slide.dataset.mediaId;
        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', t.dataset.target === id && idx === i ? 'true' : 'false');
        });
      });
    };
    slides.addEventListener('scroll', function () {
      window.clearTimeout(slides._t);
      slides._t = window.setTimeout(syncActive, 90);
    }, { passive: true });
    syncActive();
  }

  /* --------------------------------------------------------- sticky ATC */

  /* The A/B evidence here is specific: on mobile, a slide-up drawer that reads
     as its own interface stage produced +5.2% orders, while a variant that
     merely scrolled to the button produced no significant change. Never show
     the sticky bar while the real button is still on screen. */
  var sticky = $('[data-sticky-atc]');
  var anchor = $('[data-atc-anchor]', root);
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var pastAnchor = entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !entry.isIntersecting && pastAnchor);
      });
    }, { threshold: 0, rootMargin: '0px' });
    stickyObserver.observe(anchor);

    $$('[data-sticky-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!form) return;
        DCA.addToCart(new FormData(form), btn);
      });
    });
  }

  /* Rating anchor, offset so the sticky header does not eat the heading */
  $$('a[href="#reviews"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.getElementById('reviews');
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('.header-wrap');
      var offset = header ? header.offsetHeight + 16 : 16;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
    });
  });

  syncSellingPlanInput();
  update();
})();
